import {
  CoverageNeed,
  ProductName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { AdviceProductDetailsFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { TextLanguage } from "Store/texts/interfaces";
import { FormikProps } from "formik";
import React from "react";
import { AkaAdvicePriceFormValues } from "../../../interfaces";
import { DisabilityOneTimePaymentCustomerForm } from "./DisabilityOneTimePaymenCustomerForm";
import { DisabilityOneTimePaymentAdvisorForm } from "./DisabilityOneTimePaymentAdvisorForm";
import { PriceProps } from "./disabilityOneTimePaymentTypes";

type Props = PriceProps & {
  adviceDetails: AdviceProductDetailsFormValues;
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  need: CoverageNeed;
  recalculatePrice: (
    formValues: AkaAdvicePriceFormValues,
    specificProduct: ProductName,
  ) => void;
  adviceCard: any;
  lang: TextLanguage;
};

export const DisabilityOneTimePaymentForm = ({
  adviceDetails,
  formProps,
  need,
  recalculatePrice,
  adviceCard,
  lang,
  ...priceProps
}: Props): React.ReactElement | null => {
  const isAdvisor = useIsAdvisorSelector();

  if (isAdvisor) {
    return (
      <DisabilityOneTimePaymentAdvisorForm
        adviceDetails={adviceDetails}
        formProps={formProps}
        need={need}
        recalculatePrice={recalculatePrice}
        adviceCard={adviceCard}
        lang={lang}
        {...priceProps}
      />
    );
  }

  return (
    <DisabilityOneTimePaymentCustomerForm
      formProps={formProps}
      need={need}
      recalculatePrice={recalculatePrice}
      adviceCard={adviceCard}
      lang={lang}
      {...priceProps}
    />
  );
};
